import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { skuit } from 'src/services/skuit'

import { ReplenishmentListTable } from 'src/components/Table/list/Replenishment'
import { ListPage } from 'src/components/Pages/ListPage'

export const ReplenishmentListPage = () => {
  const paginator = useQueryPaginator(
    'asn-list',
    skuit.sc.freight.replenishment.list,
    { params: { page_size: 100000 } },
  )

  return (
    <ListPage
      title='Replenishment'
      paginator={paginator}
    >
      <ReplenishmentListTable
        paginator={paginator}
        fields={['client', 'sku', 'numToPick', 'totalStored', 'path']}
      />
    </ListPage>
  )
}
